import service from '../../utils/Service'

export default function getUserEvents(userId) {
   return {
      type : "FETCH_EVENTS",
      payload : service.getEvents(userId)
   }
}




// WEBPACK FOOTER //
// ./src/actions/events/getUserEventsAction.js